export interface CpLine {
  id: string;
  name: string;
  pair: string;
  tagline: string;
  intensity: number; // 0-100
  status: string;
  summary: string;
  moments: string[];
  tone: 'primary' | 'accent' | 'secondary';
}

export const cpLines: CpLine[] = [
  {
    id: 'lingxiu',
    name: '灵秀师兄妹',
    pair: '李长寿 × 蓝灵娥',
    tagline: '十年教导，一生相守',
    intensity: 95,
    status: '主线 · 修成正果',
    summary: '从兄妹到道侣的最甜双向奔赴。李长寿以十年言传身教，把小师妹一路护送到化神境界；蓝灵娥则将那份敬慕酿成深情。是整部作品感情浓度最高的官配主线。',
    moments: [
      '入门体检时，师兄第一眼就记住了这个柔柔弱弱的小师妹。',
      '深夜山巅，师兄演练法术，师妹在旁偷师又偷看他。',
      '生死关头，李长寿破例动用压箱底的本事，只为护她周全。',
      '云海之间，两人并肩而立，师妹唤出一声「师兄」，胜过千言万语。',
    ],
    tone: 'primary',
  },
  {
    id: 'jiuzu',
    name: '酒玖师姐·叔侄向',
    pair: '酒玖 × 李长寿',
    tagline: '名义师叔，实则欢喜冤家',
    intensity: 82,
    status: '高甜 · 互动名场面多',
    summary: '酒玖师叔「又飒又沙雕」的出场，让「叔侄」关系线全程高能。一边是自称长辈的酒玖，一边是满腹算计的李长寿，喝酒、斗嘴、护短的日常，贡献了最多的名场面与反差萌。',
    moments: [
      '酒玖拎着酒壶不请自来，张口就是一句「小长寿」。',
      '破天峰上，师叔醉酒，师兄稳稳接住，弹幕瞬间沦陷。',
      '李长寿遇险，酒玖收起玩闹、认真护人的那一刻，人设直接拉满。',
      '两人斗嘴互坑，到头来却一个都不舍得对方受半点伤。',
    ],
    tone: 'accent',
  },
  {
    id: 'jianyi',
    name: '江湖剑意',
    pair: '李长寿 × 敖乙',
    tagline: '剑意相通，知己难求',
    intensity: 68,
    status: '并肩 · 知己向',
    summary: '傲然天骄的东海剑修敖乙，与深藏不露的李长寿在历练中相认。一个剑心通明、一个算无遗策，从萍水相逢到并肩作战，是「江湖知己」关系线的天花板。',
    moments: [
      '乱局之中初次交锋，两人同时读出对方的不简单。',
      '敖乙亮剑的那一刻，李长寿第一次认真起来。',
      '同闯险地，剑修在前开道，炼气士在后压阵。',
      '剑意对谈，无需多言便知彼此道心。',
    ],
    tone: 'secondary',
  },
  {
    id: 'shixiongmei',
    name: '师门群像',
    pair: '李长寿 × 齐源 × 众同门',
    tagline: '一峰之人，皆是牵挂',
    intensity: 74,
    status: '日常 · 温情向',
    summary: '度仙门与破天峰的同门群像，是师门日常的底色。护短的师父、可爱的同门、互坑又互护的师兄弟，让「回家」成为全剧最戳心的关键词。',
    moments: [
      '师父嘴上嫌弃，暗地里却为徒弟备好一切。',
      '同门斗法输了也不服气，转头又一起下山喝酒。',
      '大难临头，昔日吵闹的同门齐刷刷站到师兄身后。',
      '峰顶炊烟起，一句「都回来了」便是最大的圆满。',
    ],
    tone: 'secondary',
  },
];